import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getPaymentRequestDetail } from '@src/api'
import {
  DefaultApiGetPaymentRequestDetailRequest,
  GetPaymentRequestDetail200Response,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchPaymentRequestDetail = (
  isPayable: boolean,
  params: DefaultApiGetPaymentRequestDetailRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery<
    AxiosResponse<GetPaymentRequestDetail200Response>,
    AxiosResponse<CustomError>
  >({
    enabled: !!params.organizationId && !!params.paymentRequestId && isPayable,
    queryFn: () => getPaymentRequestDetail(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_PAYMENT_REQUEST_EVIDENCE_FILE,
      params.organizationId,
      params.paymentRequestId,
    ],
  })
}
